{
  "general": {
    "title": "Otsikko"
  },
  "header": {
    "language": "Kieli",
    "help": "Ohje",
    "help_modal": {
      "description": "Jos tarvitset apua tai sinulla on kysyttävää, voit ottaa meihin yhteyttä sähköpostitse osoitteessa {mail} tai puhelimitse numerossa {phone}."
    }
  },
  "fields": {
    "error_message": "Tämä kenttä on pakollinen",
    "invalid_email": "Virheellinen sähköpostiosoite",
    "invalid_end": "Päättymisajan tulee olla alkamisajan jälkeen",
    "terms_required": "Sinun on hyväksyttävä käyttöehdot jatkaaksesi",
    "invalid_phone": "Virheellinen puhelinnumero. Kokeile lisätä maakoodi",
    "function_space_required": "Valitse kokoustila jatkaaksesi",
    "function_space_configuration_error": "Mikään kokoustila ei voi majoittaa valittua kokoonpanoasi. Säädä vieraiden määrää tai asettelun tyyppiä.",
    "function_space_date_unavailable": "Vaatimuksesi täyttävät kokoustilat eivät ole saatavilla valittuna päivänä. Valitse toinen päivämäärä.",
    "function_space_conflict_error": "Tämä toimintotila on jo valittu päällekkäiselle aikajaksolle. Valitse toinen tila tai säädä aikaa."
  },
  "reservation_steps": {
    "title": "Varauksesi:",
    "step_1": {
      "title": "Varaustiedot",
      "sub_steps": {
        "services": "Mitä haluat varata?",
        "location": "Kohteen valinta",
        "email": "Yhteystiedot"
      }
    },
    "step_2": {
      "title": "Kokoustilat",
      "sub_steps": {
        "basic_information_meeting_rooms": "Tapahtumasi",
        "days": "Tapahtuman tiedot",
        "remarks": "Lisätiedot"
      }
    },
    "step_3": {
      "title": "Hotellihuoneet",
      "title_with_date": "Hotellihuoneet päivälle {date}",
      "sub_steps": {
        "basic_information_hotel_rooms": "Tiedot"
      }
    },
    "step_4": {
      "title": "Yhteystiedot",
      "sub_steps": {
        "basic_information": "Yhteystiedot",
        "contact_person": "Laskutusosoite"
      }
    },
    "step_5": {
      "title": "Varauksen yhteenveto"
    }
  },
  "reservation_form": {
    "step_1": {
      "services": {
        "title": "Mitä haluat varata?",
        "mice": "Kokoustilat",
        "hotel": "Hotellihuoneet"
      },
      "location": {
        "title": "Kohteen valinta",
        "address": "Osoite",
        "phonenumber": "Puhelinnumero"
      },
      "contract_email": {
        "title": "Yhteystiedot",
        "field": "Sähköpostiosoite"
      }
    },
    "step_2": {
      "basic_information": {
        "title": "Tapahtumasi",
        "description_header": "",
        "description": "Valitse päivät, jolloin tapahtumasi järjestetään. Voit valita useita päiviä ja muuttaa tietoja päiväkohtaisesti.",
        "fields": {
          "event_name": "Tapahtuman nimi",
          "event_type": "Tapahtuman tyyppi",
          "number_of_guests": "Vieraiden määrä",
          "start_time": "Alkamisaika",
          "end_time": "Päättymisaika",
          "amount": "Määrä",
          "total": "Yhteensä",
          "add": "Lisää",
          "emplacement": "Asettelu"
        }
      },
      "add_day": {
        "title": "Haluatko lisätä toisen päivän?",
        "add_day": "Lisää päivä",
        "add_item": "Lisää tuote",
        "day": "Kokouspäivä {dayCount}",
        "date": "Päivämäärä",
        "select_date": "Valitse päivämäärä",
        "select_date_description": "Tämä on tapahtumasi {day}. päivä. Voit muokata tämän päivän tietoja alla.",
        "plenary_hall": "Kokoustila",
        "sub_hall": "Lisätila",
        "add_hall_description": "Lisätäksesi lisää kokoustiloja tälle päivälle, napsauta Lisää kokoustila -painiketta",
        "add_hall_required": "Koska pakettisi ei sisällä kokoustilaa, sinun on lisättävä vähintään yksi",
        "add_hall_required_error": "Lisää vähintään yksi kokoustila jatkaaksesi",
        "add_hall_button": "Lisää kokoustila",
        "package_deal": "Saatavilla olevat paketit",
        "package_deal_chosen": "Valittu paketti",
        "package_deal_available": "Saatavilla olevat paketit",
        "package_deal_items": "Lisätuotteet",
        "package_deal_items_included": "Katso sisältyvät tuotteet",
        "package_deal_spaces_included": "Sisältyvät kokoustilat",
        "additional_items": "Lisätuotteet",
        "search": "Hae",
        "no_items_found": "Tuotteita ei löytynyt",
        "choose_package_deal": "Valitse",
        "deselect_package_deal": "Poista"
      },
      "remarks": {
        "title": "Lisätiedot"
      },
      "item_types": {
        "audiovisual": "Audiovisuaalinen",
        "food_beverage": "Ruoka ja juoma",
        "other": "Muu"
      },
      "item_examples": {
        "audiovisual": "Esimerkiksi: Mikrofonit",
        "food_beverage": "Esimerkiksi: Välipalat",
        "other": "Esimerkiksi: Kukat"
      },
      "clone_day": "Kopioi päivä",
      "space_selector": {
        "show_spaces": "Valitse kokoustila",
        "hide_spaces": "Piilota kokoustilat",
        "no_selection": "Valitsemme sinulle sopivan kokoustilan yllä olevien tietojen perusteella.",
        "capacities": "Kapasiteetti asettelua kohden",
        "space_not_available": "Ei saatavilla",
        "space_already_selected": "Jo valittu",
        "space_selected": "Valittu",
        "select_space": "Valitse",
        "show_more": "Näytä lisää tiloja",
        "show_less": "Näytä vähemmän tiloja",
        "show_unavailable": "Näytä tilat, jotka eivät ole saatavilla",
        "hide_unavailable": "Piilota tilat, jotka eivät ole saatavilla",
        "unavailable_matching_spaces": "Tilat, jotka vastaavat vaatimuksiasi mutta eivät ole saatavilla",
        "no_image": "Ei kuvaa saatavilla"
      }
    },
    "step_3": {
      "booking": {
        "title": "Hotellihuoneet",
        "title_with_date": "Hotellihuoneet päivälle {date}",
        "available": "Saatavilla",
        "unavailable": "Ei saatavilla",
        "available_rooms": "{n} saatavilla",
        "quantity": "Määrä",
        "guests_per_room": "Vieraita per huone",
        "guests_per_room_with_max": "Vieraita per huone (max {max})",
        "max_guests": "Enintään {n} vierasta",
        "fields": {
          "name": "Ryhmän nimi",
          "check_in_date": "Saapumispäivä",
          "check_out_date": "Lähtöpäivä",
          "property": "Majoituspaikka",
          "number_of_rooms": "Määrä",
          "persons_per_room": "Vieraita huoneessa",
          "total_guests": "Vieraiden kokonaismäärä",
          "room_type": "Huonetyyppi",
          "late_check_out": "Myöhäinen uloskirjautuminen",
          "late_check_out_rooms": "Myöhäisen uloskirjautumisen huoneet",
          "breakfast": "Aamiainen",
          "remarks": "Lisätiedot"
        },
        "progress_selected": "Valittu",
        "max_capacity": "Enintään {count} vierasta",
        "sections": {
          "property": "Majoituksen Valinta",
          "details": "Varauksen Tiedot", 
          "room_selection": "Huoneen Valinta"
        },
        "collapsed_summary": "{selected}/{total} huonetta valittu: {date}",
        "completed": "Valmis",
        "too_many_selected": "Liikaa valittu",
        "incomplete": "Kesken"
      },
      "overnight_stay": {
        "title": "Haluatko lisätä toisen yöpymisen?",
        "button": "Lisää yöpyminen",
        "day": "Yöpyminen"
      },
      "clone_room": "Kopioi yöpyminen"
    },
    "step_4": {
      "account_details": {
        "title": "Yhteystiedot",
        "fields": {
          "first_name": "Etunimi",
          "last_name": "Sukunimi",
          "company_name": "Yritys",
          "email_address": "Sähköpostiosoite",
          "phone_number": "Puhelinnumero"
        }
      },
      "billing_address": {
        "title": "Laskutusosoite",
        "fields": {
          "address": "Osoite",
          "postal_code": "Postinumero",
          "city": "Kaupunki",
          "country": "Maa"
        }
      },
      "contact_person_location": {
        "title": "Yhteyshenkilö paikan päällä",
        "fields": {
          "copy": "Kopioi yhteystiedoista"
        }
      },
      "discount_code": "Tarjouskoodi",
      "invoice_reference": "Laskuviite"
    },
    "step_5": {
      "offer": "Tarjouksesi",
      "reservation": "Varauksesi",
      "request": "Varauksesi",
      "offer_details": "Voit tarkistaa kaikki tiedot täältä. Katso myös asiantuntemuksemme perusteella valitsemamme ehdotukset.",
      "download_pdf": "Lataa PDF",
      "hotel_only_meeting": "yöpyminen",
      "discount": "Alennus",
      "remarks": "Lisätiedot",
      "payment_method": "Maksutapa",
      "payment_done": "Maksu onnistui",
      "payment_succeeded": "Varauksesi on tehty. Lähetämme sinulle sähköpostia tietoinesi.",
      "payment_waiting": "Maksua käsitellään",
      "payment_processing": "Maksuasi käsitellään edelleen. Lähetämme sinulle sähköpostia, kun maksusi onnistuu.",
      "payment_failed": "Maksu epäonnistui",
      "payment_failed_message": "Maksun käsittelyssä tapahtui virhe. Yritä uudelleen.",
      "sub_total_exclusive_vat": "Välisumma (ilman ALV:tä)",
      "sub_total_exclusive_sales_tax": "Välisumma (ilman myyntiveroa)",
      "vat_amount": "{vat}% ALV",
      "sales_tax_amount": "{vat}% myyntivero",
      "terms_and_conditions": "Käyttöehdot",
      "minutes_left": "Pyyntöäsi pidetään voimassa vielä 1 minuutin ajan. Suorita maksu pian varmistaaksesi sen. | Pyyntöäsi pidetään voimassa vielä <strong>{count} minuuttia</strong>. Suorita maksu pian varmistaaksesi sen.",
      "seconds_left": "Sinulla on <strong>1 sekunti</strong> aikaa suorittaa maksu. Pyyntösi vanhenee pian. | Sinulla on <strong>{count} sekuntia</strong> aikaa suorittaa maksu. Pyyntösi vanhenee pian.",
      "timer": {
        "title": "Aika loppui",
        "subtitle": "Valitettavasti aikasi maksun suorittamiseen loppui. Mutta ei huolta, meillä on pyyntösi ja otamme sinuun yhteyttä mahdollisimman pian."
      },
      "basic_information": {
        "title": "Varaustiedot",
        "event_name": "Tapahtuman nimi",
        "event_type": "Tapahtuman tyyppi"
      },
      "contact_information": {
        "title": "Yhteystiedot",
        "contact_person_location": "Yhteyshenkilö paikan päällä",
        "account_details": "Yhteystiedot",
        "billing_address": "Laskutusosoite"
      },
      "day": {
        "day": "Kokouspäivä {dayCount}",
        "function_spaces": "Kokoustilat",
        "additional_function_spaces": "Lisäkokoustilat",
        "pax": "Vieraiden määrä",
        "emplacement": "Asettelu",
        "start_time": "Alkamisaika",
        "end_time": "Päättymisaika",
        "package_deals": "Paketit",
        "package_deals_details": "Sinulle valmiina oleva paketti liittyvine tuotteineen.",
        "package_deals_amount": "1 Henkilö | {count} Henkilöä",
        "package_deals_price": "{amount} per henkilö",
        "additional_items": "Lisätuotteet",
        "total": "Yhteensä",
        "vat": "sisältää ALV:n",
        "sales_tax": "ei sisällä myyntiveroa",
        "hall_rental": {
          "title": "Kokoustilan vuokra",
          "pax": "{pax} henkilöä"
        }
      },
      "hotel_room": {
        "title": "Hotellihuoneet",
        "price": "Hinta",
        "room_type": "Huonetyyppi",
        "rooms": "Huoneet",
        "number_of_rooms": "0 Huonetta | 1 Huone | {n} Huonetta",
        "per_room": "Käyttöaste",
        "pax_room": "0 Henkilöä huoneessa | 1 Henkilö huoneessa | {n} Henkilöä huoneessa",
        "breakfast_status": "Aamiainen sisältyy | Aamiainen ei sisälly",
        "late_checkout": "Myöhäinen uloskirjautuminen",
        "nights": "0 yötä | 1 yö | {n} yötä",
        "per_night": "{amount} per huone per yö",
        "breakfast_price": "{name}: {amount} per henkilö per yö",
        "late_checkout_price": "Myöhäinen uloskirjautuminen: {amount} per huone",
        "city_tax": "Ei sisällä kaupunkiveroa",
        "guests": "Vieraat",
        "number_of_guests": "0 Vierasta | 1 Vieras | {n} Vierasta"
      },
      "multi_venue_alert": {
        "title": "Useaa kohdetta koskeva varaus",
        "description": "Hotellihuoneet on varattu eri kohteissa. Katso tiedot alta."
      }
    },
    "modal": {
      "confirm_turn_down": {
        "title": "Haluatko varmasti hylätä tämän tarjouksen?",
        "body": "Tätä ei voi perua.",
        "checkbox": "Hyväksyn, että hylkään tämän tarjouksen peruuttamattomasti."
      },
      "confirm_cancel": {
        "title": "Haluatko varmasti peruuttaa tämän varauksen?",
        "body": "Käyttöehdot ovat voimassa.",
        "checkbox": "Olen lukenut ja ymmärtänyt <a href='{termsUrl}' target='_blank'>käyttöehdot</a> ja hyväksyn ne."
      },
      "confirm_accept": {
        "title": "Vahvista varauksesi",
        "body": "Käyttöehdot ovat voimassa.",
        "checkbox": "Olen lukenut ja ymmärtänyt <a href='{termsUrl}' target='_blank'>käyttöehdot</a> ja hyväksyn ne."
      },
      "reservation_edited": {
        "title": "Kiitos paljon. Muutoksesi on tehty."
      },
      "reservation_submitted": {
        "title": "Kiitos paljon varauksestasi",
        "body": "Saat tarjouksen varauksestasi mahdollisimman pian.",
        "button": "Klikkaa tästä vieraillaksesi {locationName} verkkosivustolla"
      },
      "reservation_accepted": {
        "body": "Saat vahvistuksen varauksestasi mahdollisimman pian."
      },
      "reservation_cancelled": {
        "title": "Olet peruuttanut varauksen {meeting}."
      },
      "reservation_turned_down": {
        "title": "Olet hylännyt tarjouksen {meeting}."
      },
      "cancel_reason": {
        "text": "Peruutuksen syy",
        "placeholder": "Kerro miksi peruutat tämän varauksen."
      },
      "turn_down_reason": {
        "text": "Hylkäämisen syy",
        "placeholder": "Kerro miksi hylkäät tämän tarjouksen."
      },
      "submitting": {
        "title": "Käsittelemme pyyntöäsi",
        "subtitle": "Tämä voi kestää hetken. Älä sulje tätä ikkunaa."
      },
      "request": {
        "loading_title": "Luomme valinnaista varaustasi",
        "submitted_text": "Saat tarjouksen varauksestasi mahdollisimman pian."
      },
      "inquire": {
        "loading_title": "Luomme tiedusteluasi",
        "submitted_text": "Otamme sinuun yhteyttä mahdollisimman pian."
      },
      "book": {
        "loading_title": "Laskemme hintaa",
        "submitted_text": ""
      }
    },
    "buttons": {
      "edit_reservation": "Muokkaa varausta",
      "save_pdf": "Tallenna tarjous PDF-muodossa",
      "submit_offer": "Pyydä tarjous",
      "next_step": "Seuraava vaihe",
      "previous_step": "Edellinen vaihe",
      "accept_offer": "Hyväksy tarjous",
      "cancel_offer": "Peruuta varaus",
      "turn_down_offer": "Hylkää tarjous",
      "edit_offer": "Tallenna muutokset",
      "request_proposal": "Pyydä ehdotus",
      "request": "Pyydä ehdotus",
      "inquire": "Varaa",
      "book": "Varaa nyt",
      "accept_booking": "Vahvista varaus",
      "pay_booking": "Maksa",
      "cancel_booking": "Peruuta varaus"
    },
    "basket": {
      "cart": "Hinnan esikatselu",
      "event": "Tapahtuma",
      "hotel_rooms": "Hotellihuoneet",
      "estimated_fees": "Arvioidut maksut",
    "event_subtotal": "Tapahtuman välisumma",
    "hotel_room_subtotal": "Hotellihuoneiden välisumma",
      "guests": "vierasta",
      "meeting_space": "Kokoustila",
      "additional_services": "Lisäpalvelut",
      "room": "huone",
      "rooms": "huonetta",
      "tax_breakdown": "Veroerittely",
      "subtotal_with_rate": "Välisumma ({rate}% ALV)",
      "vat_with_rate": "ALV ({rate}%)",
      "sales_tax_with_rate": "Myyntivero ({rate}%)",
      "total_excluding_tax": "Yhteensä ilman ALV:tä",
      "total_excluding_sales_tax": "Yhteensä ilman myyntiveroa",
      "total_tax": "Yhteensä ALV",
      "total_sales_tax": "Yhteensä myyntivero",
      "total_including_taxes": "Yhteensä sis. ALV",
      "total_including_sales_taxes": "Yhteensä sis. myyntivero",
      "empty_cart": "Lisää kohteita varaukseen nähdäksesi hintatiedot.",
      "pricing_unavailable": "Hintojen esikatselu ei ole saatavilla tälle varaukselle. Saat yksityiskohtaiset hintatiedot varausuunne käsittämisen jälkeen."
    }
  },
  "dropdown": {
    "no_results": "Ei tuloksia",
    "placeholder": "Valitse vaihtoehto",
    "loading": "Ladataan..."
  },
  "switch": {
    "yes": "Kyllä",
    "no": "Ei"
  },
  "enums": {
    "payment_method": {
      "AT_LOCATION": "Paikan päällä",
      "CREDIT_CARD": "Luottokortti",
      "INVOICE": "Lasku",
      "PRE_PAYMENT": "Ennakkomaksu",
      "VOUCHER": "Lahjakortti"
    }
  },
  "price_types": {
    "per_guest": "Per Vieras",
    "per_unit": "Per Yksikkö",
    "per_guest_explanation": "{price} per vieras",
    "per_unit_explanation": "{price} kiinteä hinta"
  }
}